import React from "react"
import { SocialIcon } from "react-social-icons"

function Footer() {
  return (
    <div>
      <footer className="py-2" style={{ backgroundColor: "#315bf3" }}>
        <div className="container">
          <p className="float-right">COS ELECTRONICS | © Copyright 2020</p>
          <p>
            Designed by{" "}
            <a href="url">
              SK
            </a>
          </p>
        </div>
      </footer>
    </div>
  )
}

export default Footer